import { Component, ElementRef, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DialogBaseComponent, DialogParams } from '@/shared/dialog-base.component';
import { DomainService } from '@/shared/domain.service';
import { UtilFns } from '@/shared/util-fns';

export interface FreightEntryDialogParams extends DialogParams {
  invoiceId: string;
  accountName: string;
  currentFreight: number;
}

@Component({
  templateUrl: './freight-entry-dialog.component.html',
  standalone: false,
})
export class FreightEntryDialogComponent extends DialogBaseComponent<FreightEntryDialogParams> {
  @ViewChild('firstInput') firstInput: ElementRef<HTMLInputElement>;

  freightAmt = 0;

  constructor(
    public config: DynamicDialogConfig<FreightEntryDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService,
  ) {
    super(config, dialogRef, domainService);
    this.prepare();
  }

  private async prepare() {
    this.freightAmt = this.params.currentFreight ?? 0;
    this.config.header = `Freight for Invoice ${this.params.invoiceId}`;
    this.isPageReady = true;

    await UtilFns.wait(1);
    this.firstInput?.nativeElement?.focus();
    this.firstInput?.nativeElement?.select?.();
  }

  ok() {
    const amt = Math.max(0, +(this.freightAmt ?? 0));
    this.dialogRef.close(amt);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
